export default __webpack_public_path__ + "static/media/placeholder_dummy2016-apotheke01-de.5a7974b2.png";